import posthog from 'posthog-js'
import { createActions } from 'redux-actions'

import { eventTracker } from '@masterplandev/utils'

import keycloak from '@/core/keycloak'
import { removeLocalStorageItem } from '@/core/utils/localStorage/removeLocalStorageItem'
import { removeCurrentBrowserFcmToken } from '@/push-notifications/utils/fcmToken'

/**
 * @deprecated
 */
const actions = createActions(
  {
    USER: {
      GET: () => ({
        options: { returnRejectedPromiseOnError: false },
        request: {
          url: '/users/current',
        },
      }),
      EMAIL: {
        PUT: (data) => ({
          request: {
            url: '/scorm/user/email',
            method: 'PUT',
            data,
          },
        }),
      },
      UPDATE_EMAIL: (email) => email,
    },
  },
  'UPDATE_ACCOUNT',
)

/**
 * @deprecated
 */
const logout = () =>
  function userLogout() {
    // Unconditional: removal uses the token stored at registration, so a
    // forced or expired session is exactly when it still has to run.
    removeCurrentBrowserFcmToken()

    removeLocalStorageItem('masterplan')
    removeLocalStorageItem('seen_notifications')

    eventTracker.reset()
    posthog.reset()

    if (keycloak.authenticated) {
      const currentUrl = new URL(window.location.href)
      keycloak.logout({ redirectUri: currentUrl.origin })
    } else {
      window.location.pathname = '/'
    }
  }

/**
 * @deprecated
 */
export default {
  ...actions.user,
  updateAccount: actions.updateAccount,
  logout,
}
